import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatMenuModule, MatFormFieldModule, MatDialog } from '@angular/material';

@Component({
  selector: 'app-mapsketchdialog',
  templateUrl: './mapsketchdialog.component.html',
  styleUrls: ['./mapsketchdialog.component.scss']
})
export class MapsketchdialogComponent implements OnInit {

  constructor(public addSketchDialog: MatDialogRef<MapsketchdialogComponent>) { }

  sketchName : string;

  ngOnInit() {
  }

  OnCloseConfirm(){
    this.addSketchDialog.close(this.sketchName);
  }

  OnCloseCancel() {
    this.addSketchDialog.close('Cancel');
  }
}
